export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}

export const convertBase64toBlob = (data) => {
  var content = atob(data)
  var ab = s2ab(content)
  return new Blob([ab], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
}

const s2ab = (s) => {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}



// WEBPACK FOOTER //
// ./src/helpers/general.js